import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Organization } from '../objects/organization';
import { OrganizationParameter } from '../objects/organization-parameter';
import { Observable } from 'rxjs/Observable';
import { AppService } from './app.service';
import { ProviderParameter } from '../../main/pages/provider-characteristic/resolver/provider-characteristic-resolver.service';
import {logger} from 'codelyzer/util/logger';

@Injectable()
export class ApiService {

  private apiURL = environment.apiUrl;
  private SUB_URL = environment.subscriptionApiUrl;

  constructor(private http: HttpClient, private appService: AppService) {

  }

  authenticate(email: string, password: string) {
    const request = {
      client_key: environment.clientKey,
      client_secret: environment.clientSecret,
      username: email,
      password: password
    };
    return this.http.post<ApiResponse>(this.SUB_URL + '/subscription' + '/accounts/login', request);
  }

  getAuthUserRoles(userID) {
    return this.http.get<ApiResponse>(this.SUB_URL + `/subscription/users/${userID}/role`);
  }

  userAuthenticate() {
    return this.http.post<ApiResponse>(`${this.SUB_URL}/subscription/accounts/authenticate`, {});
  }

  createOrganization(organization) {
    return this.http.post<ApiResponse>(this.apiURL + '/registration/organizations', organization);
  }

  createAgency(agency) {
    return this.http.post<ApiResponse>(this.apiURL + '/registration/agencies', agency);
  }

  getOrganizations(type: string) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/type/${type}`);
  }

  getOrganizationByID(organizationID) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}`);
  }

  getOrganizationByName(organizationName) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/name/${organizationName}`);
  }

  getOrganizationParameters(organizationID: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/parameter`);
  }

  getOrganizationProviders(organizationID, providerFilter?) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/parameter/context?${providerFilter}`);
  }
  updateCostCenter(organizationID, costCenterID, data) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/costcenter/${costCenterID}`, data);
  }
  createCostCenter(organizationID,data) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/costcenter`, data);
  }
  deleteCostCenter(organizationID,itemId) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/costcenter/${itemId}`);
  }
  getCostCenters(organizationID,) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/costcenter`);
  }
  deleteOrganizationParameters(organizationID: number, parameterID: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/parameter/by/${parameterID}`);
  }

  deleteOrganizationProvider(organizationID,context) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/parameter/${context}`);
  }

  addOrganizationParameter(organizationID: number, organizationParameter) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/parameter`, organizationParameter);
  }

  updateOrganizationParameter(organizationID: number, parameterID: number, organizationParameter) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/parameter/${parameterID}`, organizationParameter);
  }


  addTvLoginParameter(organizationID: number, organizationParameter) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/tv/organizations/${organizationID}/parameter`, organizationParameter);
  }


  getOrganizationDeposits(organizationID: number, crossID: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/deposit/${crossID}`);
  }

  getOrganizationCrossParameters(organizationID: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/crossparameter`);
  }

  updateOrganization(organizationID: number, organization) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}`, organization);
  }

  getCrossOrganizations(organizationID: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/cross`);
  }

  getOrganizationsByIds(ids) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations?id_In=${ids}`);
  }

  getOrganizationAgency(organizationID: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/agency`);
  }

  getAgencyOrganizations(agencyId: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/agency/${agencyId}/organizations`);
  }

  deleteCrossOrganization(organizationID: number, crossID: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/cross/${crossID}`);
  }

  updateCrossOrganization(organizationID: number, crossID: number, crossOrganization) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/cross/${crossID}/change/${crossOrganization.id}`, crossOrganization);
  }

  //ParentAgencyComponent -> insertAgency //bu yeni cross olusturuyor
  insertCrossOrganization(organizationID: number, crossOrganizationID: number) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/NewCross/${crossOrganizationID}`, "?");
  }

  deleteCrossOrganizationParameter(parameterId, organizationID: number, crossOrgId: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/cross/${crossOrgId}/parameter/${parameterId}`);
  }

  updateCrossParameter(organizationID: number, crossID: number, parameterID: number, parameter) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/cross/${crossID}/parameter/${parameterID}`, parameter);
  }

  //bir agenta/organizasyonun mevcut cross unun crossparametre vuruyor
  postCrossParameter(organizationID: number, crossID: number, parameter) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/crossparameter/${crossID}`, parameter);
  }

  deleteCrossParameter(organizationID: number, crossID: number, parameterID: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/cross/${crossID}/parameter/${parameterID}`);
  }


  deleteDeposit(organizationID: number, depositID: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/deposit/${depositID}`);
  }

  addDeposit(organizationID: number, crossOrganizationID: number, deposit) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/deposit/${crossOrganizationID}`,
      deposit);
  }

  inactivateOrganization(organizationID: number) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/inactivate`, {});
  }

  getOrganizationDomains(organizationID: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/domains`);
  }

  addOrganizationDomain(organizationID: number, domain) {
    return this.http.post<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/domains`, domain);
  }

  deleteOrganizationDomain(organizationID: number, domainID: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/domains/${domainID}`);
  }

  updateOrganizationDomain(organizationID: number, domainID: number, domain) {
    return this.http.put<ApiResponse>(this.apiURL + `/registration/organizations/${organizationID}/domains/${domainID}`, domain);
  }

  getProviderCharacteristicList() {
    return this.http.get<ApiResponse>(this.apiURL + `/settings/providercharacteristic`);
  }

  getProviderCharacteristicByID(id: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/settings/providercharacteristic/${id}`);
  }

  deleteProviderCharacteristicByID(id: number) {
    return this.http.delete<ApiResponse>(this.apiURL + `/settings/providercharacteristic/${id}`);
  }

  addProviderCharacteristic(providerParameter: ProviderParameter) {
    return this.http.post<ApiResponse>(this.apiURL + `/settings/providercharacteristic`, providerParameter);
  }

  updateProviderCharacteristic(id: number, providerParameter: ProviderParameter) {
    return this.http.put<ApiResponse>(this.apiURL + `/settings/providercharacteristic/${id}`, providerParameter);
  }

  getHotels(query?) {
    let param = query ? ('?' + query.toString()) : '';
    return this.http.get<ApiResponse>(this.apiURL + `/systemhotels/hotels${param}`);
  }

  matchHotels(data) {
    return this.http.post<ApiResponse>(this.apiURL + `/systemhotels/matchHotels`, data);
  }

  createOffer(data, hotelId, orgId) {
    return this.http.post<ApiResponse>(this.apiURL + `/systemhotels/${orgId}/offers/${hotelId}/offers`, data);
  }

  createPrice(priceCpData, hotelId, offerId, orgId) {
    return this.http.post<ApiResponse>(this.apiURL + `/systemhotels/${orgId}/offers/${hotelId}/offers/${offerId}/prices`, priceCpData);
  }

  createOrganizationHotel(data) {
    return this.http.post<ApiResponse>(this.apiURL + `/systemhotels/hotels/organizationHotel`, data);
    //return this.httpClient.post<ApiResponse>(`${this.BTM_URL}/btm/hotels/organizationHotel`, data);
  }

  updateHotelStatus(id: number, data) {
    return this.http.put<ApiResponse>(this.apiURL + `/systemhotels/${id}/status`, data);
  }
  getHotelById(id: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/systemhotels/${id}`);
  }
  getHotelOrganizationHotelsByHotelId(id: number) {
    return this.http.get<ApiResponse>(this.apiURL + `/systemhotels/${id}/organizationHotels`);
  }

  updateBiziHotelGeneralInfo(hotelId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/generalInfo`, data);
  }

  updateBiziHotelLocationInfo(hotelId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/addressInfo`, data);
  }

  updateBiziHotelServicesInfo(hotelId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/services`, data);
  }

  deleteBiziHotelInfoImage(hotelId, data) {
    return this.http.request<ApiResponse>('DELETE', `${this.apiURL}/systemhotels/${hotelId}/image`, data);
  }

  getBiziHotelInfoImages(hotelId) {
    return this.http.get<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/infoImages`);
  }

  addBiziHotelImage(hotelId, data) {
    return this.http.post<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/image`, data);
  }

  updateBiziHotelImage(hotelId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/image`, data);
  }

  updateBiziHotelInfoImages(hotelId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/systemhotels/${hotelId}/infoImages`, data);
  }

  updateOrganizationHotel(orgId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/systemhotels/organizationHotel/${orgId}`, data);
  }

  addBiziHotel(data) {
    return this.http.post<ApiResponse>(`${this.apiURL}/systemhotels/newHotel`, data);
  }
  getSystemHotels(searchParams) {
    return this.http.get<ApiResponse>(`${this.apiURL}/systemhotels/hotels/export?${searchParams}`);
  }
  getHotelRegistrations(queryParams) {
    return this.http.get<ApiResponse>(`${this.apiURL}/hotel/registrations?${queryParams}`);
  }

  confirmHotelRegistration(registrationId,data){
    return this.http.put<ApiResponse>(`${this.apiURL}/hotel/registrations/${registrationId}/accept`,data);
  }
  rejectHotelRegistration(registrationId,hotelId){
    return this.http.put<ApiResponse>(`${this.apiURL}/hotel/registrations/${registrationId}/decline`,{});
  }

  downloadFiles(hotelId:any,name:any) {
    let url = `${this.apiURL}/hotel/registrations/${hotelId}/file/${name}`;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(url, { headers: headers, responseType: 'blob' });
  }
  getRoomChanges() {
    return this.http.get<ApiResponse>(`${this.apiURL}/hotel/rooms`);
  }
  roomUpdate(roomId, data) {
    return this.http.put<ApiResponse>(`${this.apiURL}/hotel/rooms/${roomId}`, data);
  }
  getHotelChanges() {
    return this.http.get<ApiResponse>(`${this.apiURL}/hotel/hotels`);
  }
  getHotelLast(hotelId):Observable<ApiResponse> {
    let param = hotelId ? ('?hotelId_In=' + hotelId.toString()) : '';
    return this.http.get<ApiResponse>(this.apiURL + `/systemhotels/hotels${param}`);
  }
  getHotelChangesById(hotelId) {
    return this.http.get<ApiResponse>(`${this.apiURL}/hotel/hotels/${hotelId}`);
  }
  updateHotelChanges(hotelId,data){
    return this.http.put<ApiResponse>(`${this.apiURL}/hotel/hotels/${hotelId}`, data);
  }
  getImagesChanges() {
    return this.http.get<ApiResponse>(`${this.apiURL}/hotel/images`);
  }
  deleteHotelImage(imageId,data) {
    return this.http.request<ApiResponse>('DELETE', `${this.apiURL}/hotel/images/${imageId}`, data);
  }
  updateHotelImages(imageId,data){
    return this.http.put<ApiResponse>(`${this.apiURL}/hotel/images/${imageId}`, data);

  }

  getSupportUsers(pagination){
    return this.http.get<ApiResponse>(this.SUB_URL + `/subscription/users/supportuser?${pagination}`)
  }

  getUsers(organizationId, pagination){
    return this.http.get<ApiResponse>(`${this.apiURL}/registration/organizations/${organizationId}/users?${pagination} `)
  }
  resetPassword(organizationId,userId){
    return this.http.put<ApiResponse>(`${this.apiURL}/registration/organizations/${organizationId}/users/${userId}/reset_attempt`,{})
  }

  getBankBinNumbers(pagination) {
    return this.http.get<ApiResponse>(`${this.apiURL}/registration/binnumbers?${pagination} `)
  }
  deleteBinNumber(id) {
    return this.http.delete<ApiResponse>(`${this.apiURL}/registration/binnumbers/${id}`,{})
  }
  updateBinNumber(data, id) {
    return this.http.put<ApiResponse>(`${this.apiURL}/registration/binnumbers/${id}`,data);

  }
  createBinNumber(data: {bin_number: string, bank:string}) {
    return this.http.post<ApiResponse>(`${this.apiURL}/registration/binnumbers`,data);
  }
}

export class ApiResponse {
  data: any;
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/utils/services/api.service.ts